import React, { Component } from 'react'
import Camera from 'react-html5-camera-photo'
import 'react-html5-camera-photo/build/css/index.css'

class ImageCapture extends Component {
  state = {}
  render() {
    const { ...props } = this.props
    return <Camera {...props} />
  }
}

export default ImageCapture



// WEBPACK FOOTER //
// ./src/components/ImageCapture.js